import React, {useState} from 'react';
import {Container, Col, Button} from 'react-bootstrap';
import {BackgroundImageStyle, TextStyle} from '../assets/css/Styles';
import {AiOutlineArrowRight, AiOutlineArrowDown} from 'react-icons/ai';
import '../assets/css/Animations.css';

/**
 *
 * @param  {Object} props - props for the BackgroundImage component
 * @return {Component} page background image component
 */
export default function BackgroundImage({...props}) {
  const [exploreHover, setExploreHover] = useState(false);
  const [displayTopBorder, setDisplayTopBorder] = useState(false);
  const [displayBottomBorder, setDisplayBottomBorder] = useState(false);
  const [displayHeaderName, setDisplayHeaderName] = useState(false);
  const [displayTitle, setDisplayTitle] = useState(false);
  const [displayBackgroundImage, setDisplayBackgroundImage] = useState(false);
  const [displayExploreButton, setDisplayExploreButton] = useState(false);

  // delays before showing the contents on the header background image
  setTimeout(() => {
    setDisplayHeaderName(true);
  }, 500);
  setTimeout(() => {
    setDisplayTopBorder(true);
  }, 1000);
  setTimeout(() => {
    setDisplayBottomBorder(true);
  }, 1500);
  setTimeout(() => {
    setDisplayTitle(true);
  }, 2000);
  setTimeout(() => {
    setDisplayBackgroundImage(true);
  }, 3000);
  setTimeout(() => {
    setDisplayExploreButton(true);
  }, 3500);

  return (
    <div style={BackgroundImageStyle.backgroundImageStyle}>
      <div
        style={displayBackgroundImage ?
          BackgroundImageStyle.contentDIvActive :
          BackgroundImageStyle.contentDIvInactive
        }>
        <Container style={BackgroundImageStyle.contentContainer}>
          {
            displayTopBorder &&
            <Col
              id='header-name-top-border'
              style={BackgroundImageStyle.borderCol}
            />
          }
          {displayHeaderName &&
            <Col id='header-name' style={BackgroundImageStyle.NameCol}>
              <span
                style={TextStyle.mainTitleTxt}>GYIMAH CLEMENT</span>
            </Col>
          }
          {
            displayBottomBorder &&
            <Col
              id='header-name-top-border'
              style={BackgroundImageStyle.borderCol} />
          }
          {
            displayTitle &&
            <Col id='my-title' style={BackgroundImageStyle.professionCol}>
              <span style={TextStyle.normalTxt0}>FULL STACK ENGINEER</span>
            </Col>
          }
          {
            displayExploreButton &&
            <Button
              id='my-title'
              onMouseEnter={() => setExploreHover(true)}
              onMouseLeave={() => setExploreHover(false)}
              style={exploreHover ?
                    BackgroundImageStyle.exploreButtonActive :
                    BackgroundImageStyle.exploreButton}
              onClick={() => props.scrollToAboutMe()}>
              <span style={TextStyle.normalTxt1}>EXPLORE</span>
              {
              exploreHover ?
                <AiOutlineArrowDown
                  id='explore-arrow-down'
                  style={BackgroundImageStyle.exploreIcon}
                /> :
                <AiOutlineArrowRight
                  id='explore-arrow-right'
                  style={BackgroundImageStyle.exploreIcon}
                />
              }
            </Button>
          }
        </Container>
      </div>
    </div>
  );
}
